import { render, staticRenderFns } from "./BaseFormElement.vue?vue&type=template&id=224e172c&"
import script from "./BaseFormElement.vue?vue&type=script&lang=ts&"
export * from "./BaseFormElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports